import { Operation } from './Operation';

export interface Customer {
  id: string;
  localUuid?: string;
  name: string;
  type: string;
  customerNumber: string;
  contactPerson: string
  contactPersonFunction: string
  email: string;
  phone: string;
  address: Address;
  responsibleConsultant: string;
  createdAt: Date;
  updatedAt: Date;
  additionalAddresses: Address[] | null;
}
export interface Address {
  street: string;
  streetNumber: string;
  city: string;
  zip: string;
  country?: string;
  thermalLine?: boolean;
  type?: string;
  consumption?: string;
  unit?: string;
  supplier?: string;
}

export const getAddressDisplayName = (address: Address) => (
  address ? `${address.street} ${address.streetNumber} - ${address.zip} ${address.city}` : 'Unbekannt'
);

export type CustomerType = {
  current: Customer | null;
}

export type CustomersListType = {
  list: Customer[] | null;
}
export interface CustomerWithOperations extends Customer {
  operations: Operation[];
}

export type CustomerWithOperationsListType = {
  list: CustomerWithOperations[] | null;
}
